import request from '@/utils/request';

/**
 * 获取单个类型的内容
 * @param {string} type - 内容类型 (about: 关于我们, contact: 联系我们, agreement: 用户协议, privacy: 隐私政策)
 * @returns {Promise} - 返回请求结果
 */
export function getAboutContent(type = 'about') {
  return request({
    url: '/api/about/index',
    method: 'get',
    params: { type }
  });
} 